<template>

  <el-container>
    <!-- VALIDACIÓN DE SESIÓN -->
    <div v-if="verificandoCredenciales === true || cerrandoSesion === true"></div>

    <!-- MAIN VIEW -->
    <MainContainer v-else />
    
    <!-- MODAL DE SESIÓN EXPIRADA -->
    <SesionExpiradaModal 
      v-if="showModalSesionExpirada"
      :onCloseModal="onCloseSesionExpiradaModal" 
    />

  </el-container>

</template>

<script>
  import { mapState } from 'vuex'
  import MainContainer from './MainContainer'
  import Login from '../Login/login'
  import SesionExpiradaModal from './sesionExpiradaModal'

  export default {
    name: 'Main',
    components: { MainContainer, Login, SesionExpiradaModal },
    data(){ 
      return {
        showModalSesionExpirada: false
      }
    },
    computed: {
      ...mapState({
        verificandoCredenciales: state => state.sesion.verificandoCredenciales,
        cerrandoSesion: state => state.sesion.cerrandoSesion,
        sesionExpirada: state => state.sesion.sesionExpirada
      }),
    },
    methods: {
      onCloseSesionExpiradaModal() {
        // cierro el modal
        this.showModalSesionExpirada = false

        // cierro sesión
        this.$store.dispatch('sesion/cerrarSesion')
        .then(()=> this.$router.push({ name: 'Login' }))
      }
    },
    mounted()
    {
      // muestro el loader de verificación de credenciales
      let loading = this.$loading({
        lock: true,
        text: this.$t('GENERAL_checkingCredentials'),
        spinner: 'el-icon-loading'
      })

      // verifico las credenciales y cierro el loader      
      this.$store.dispatch('sesion/verificarCredenciales')
      .then((resultadoAuth) => { 
        loading.close() 
        if(resultadoAuth === undefined)
        this.$router.push({name: 'Login'})
      })
    },
    watch: {
      sesionExpirada(newVal) {
        
        if(newVal === false)
          return
        
        // muestro el modal de sesión expirada
        this.showModalSesionExpirada = true

        // vuelvo el valor de sesión expirada a falso para que vuelva a mostrar el modal en caso de navegación
        this.$store.commit('sesion/setSesionExpirada', false)
      }
    }
  }
</script>